const ACCESS_TOKEN = "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp";

const LANG_ID_TO_CODE = {
  "2224": "en",
  "2225": "id",
  "2226": "cn",
};

const sanitizeText = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";

  const lowered = trimmed.toLowerCase();
  if (lowered === "undefined" || lowered === "null") return "";

  return trimmed;
};

const normalizeLangId = (value) => {
  const langId = parseInt(String(value ?? ""), 10);
  if (!Number.isFinite(langId) || langId <= 0) return "";
  return String(langId);
};

export const syncProfileLanguageFromGetProfile = async ({ userId, userName } = {}) => {
  const resolvedId = parseInt(
    String(userId ?? localStorage.getItem("userID") ?? ""),
    10,
  );

  if (!Number.isFinite(resolvedId) || resolvedId <= 0) {
    return null;
  }

  const resolvedUserName =
    sanitizeText(userName) || sanitizeText(localStorage.getItem("username"));

  const fallbackLangId =
    parseInt(localStorage.getItem("languageId") || "2224", 10) || 2224;

  try {
    const response = await fetch(
      "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserName: resolvedUserName,
          ID: resolvedId,
          LangId: fallbackLangId,
          UserToken: "",
          Token: {
            AccessToken: ACCESS_TOKEN,
          },
        }),
      },
    );

    if (!response.ok) {
      return null;
    }

    const payload = await response.json();
    const profile = payload?.Profiles?.[0];
    if (!profile) {
      return null;
    }

    const normalizedLangId = normalizeLangId(
      profile.LangId ?? profile.LANG_ID ?? profile.langId,
    );
    const languageDescription = sanitizeText(
      profile.LangDesc ?? profile.LANG_DESC ?? profile.langDesc,
    );

    if (normalizedLangId) {
      localStorage.setItem("languageId", normalizedLangId);

      const languageCode = LANG_ID_TO_CODE[normalizedLangId];
      if (languageCode) {
        localStorage.setItem("language", languageCode);
        localStorage.setItem("profileLanguage", languageCode);
      }
    }

    if (languageDescription) {
      localStorage.setItem("languageDesc", languageDescription);
    }

    return {
      langId: normalizedLangId || null,
      langDesc: languageDescription || null,
    };
  } catch (error) {
    console.error("Failed to sync language from profile:", error);
    return null;
  }
};
